import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MenuModel } from '../../models/menu.model';
import { PermissionModel } from '../../models/permission.model';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit, OnChanges {

  @Input() item: MenuModel;
  @Input() permissions: PermissionModel[];
  step = -1;
  
  constructor() { }

  ngOnInit() {
    this.item.root.forEach(x => {
      if (x.permissionId === 0)
        x.visible = true;
      else if (x.permissionId > 0 && this.permissions && this.permissions.findIndex(i => i.PermissionId === x.permissionId) > -1)
        x.visible = true;
      else
        x.visible = false;
    });
  }

  ngOnChanges(){
    this.item.root.forEach(x => {
      if (x.permissionId === 0)
        x.visible = true;
      else if (x.permissionId > 0 && this.permissions && this.permissions.findIndex(i => i.PermissionId === x.permissionId) > -1)
        x.visible = true;
      else
        x.visible = false;
    });
  }


  setStep(index: number) {
    this.step = index;
  }

}
